import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import styled from 'styled-components';
import 'sweetalert2/src/sweetalert2.scss';
import {
  fetchUserFields,
  fetchUserGroups,
  setPlaybackFlags,
  setPlayingDocumentId,
  updateUserFields
} from '../../../redux/actions/app-actions';
import {
  fetchAllFlagsByDocumentUrl,
  resetFlagCreationStatus,
  setAiFilter,
  setFilterByThumbs,
  setFilters,
  setMyFilter,
  setFlagFilters,
  setPdfFlags,
  setSharedFilter,
  setTypeFilter
} from '../../../redux/actions/pdf-actions';
import {
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setIsSelectedFlags,
  setPlayerDocument,
  setPlayerFlag,
  setPlayResource,
  setShowSkipButton
} from '../../../redux/actions/player-actions';
import {
  ALLOWED_ORIGINS,
  default as config,
  initialFlagFilters,
  MOBILE_MAX_WIDTH,
  RESERVED_TAGS
} from '../../../constants/constants';
import { firebase } from '../../../firebase';
import { onMessageListener, requestForToken } from '../../../firebase/firebase';
import {
  classifyFlagsForDeletionAndSharing,
  handleDeleteFlags
} from '../../../utils/flag';
import highlightButton from '../../../images/btn-highlight.png';
import logo from '../../../images/inflo_logo.png';
import { fetchSearchFlags } from '../../../redux/actions/flag-actions';
import { displayNotification, showAlertForError } from '../../../utils/utils';
import ConfirmationDeleteModal from '../../flags/components/ConfirmationDeleteModal';
import {
  addTrackPositionToUnmatchedFlag,
  applyFilters,
  arraysAreEqual,
  groupedByText
} from '../utils/utils';
import ShareFlags from '../../../components/share-flags/ShareFlags';
import SkeletonWave from '../../../components/ui/skeleton/SkeletonWave';
import AlertLengthModal from './modals/AlertLengthModal';
import CommentModal from './modals/CommentModal';
import HighlightModal from './modals/HighlightModal';
import FlagsRightSide from './flags-right-side/FlagsRightSide';
import { logFlag } from '../api/flags';
import {
  createHighlightByPage,
  highlightUnmatchedFlag
} from '../utils/helpers';
import { scrollToTop } from '../../../utils/scrollToUtil';
import { withRouter } from 'react-router';
import { PdfViewerHeadline } from './PdfViewerHeadline';
import { FlagsFullscreenOverlay } from './FlagsFullscreenOverlay';
import HighlightFlagWithJudgement from './modals/HighlightFlagWithJudgement';

const SkeletonWrapper = styled.div`
  border: solid 1px #ddd;
  height: 100vh;
`;

const SkeletonHeader = styled.div`
  margin-bottom: 40px;
`;

const SkeletonBody = styled.div`
  padding: 0 10%;
`;

function getFirst15Words(text) {
  const words = text.split(' ');
  const first15Words = words.slice(0, 15);
  return first15Words.join(' ');
}

const PdfViewerComponent = ({
  document, // the document's url
  episode, // the row selected: the entire document object with all the info
  setPlayerFlag1,
  setPlayResource1,
  setPlayerDocument1,
  setPlayingDocumentId1,
  setDisableSkipBackButton1,
  setPlaybackFlags1,
  setDisableSkipAheadButton1,
  getUserGroups,
  filterByThumbs,
  myFilter,
  sharedFilter,
  aiFilter,
  getAllFlagsByDocumentUrl,
  setPdfFlags,
  pdfFlags,
  playerDocument,
  newFlags,
  pdfViewerDocumentId,
  typeFilter,
  setUserFields,
  getUserFields,
  expand,
  handleClickExpand,
  handleClosePdfViewer,
  setFlagFilters,
  setAiFilter,
  setMyFilter,
  setSharedFilter,
  allFlagsByDocument,
  isFlagCreatedByPlayer,
  resetFlagCreationStatus,
  allDocuments,
  userFields,
  location,
  episodeId
}) => {
  const containerRef = useRef(null);
  const isSetupComplete = useRef(false);

  const [selectedText, setSelectedText] = useState(null);
  const [selectedObj, setSelectedObj] = useState(null);
  const [showCaptureFlagModal, setShowCaptureFlagModal] = useState(false);
  const [startPageIndex, setStartPageIndex] = useState(0);
  const [endPageIndex, setEndPageIndex] = useState(0);
  const [inputTagName, setInputTagName] = useState('');
  const [inputCommentName, setInputCommentName] = useState('');
  const [radioButtonValue, setRadioButtonValue] = useState('');
  const [PSPDFKit, setPSPDFKit] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [shouldShowCustomMenu, setShouldShowCustomMenu] = useState(false);
  const [currentAnnotation, setCurrentAnnotation] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [
    openConfirmationDeleteFlagModal,
    setOpenConfirmationDeleteFlagModal
  ] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [flagsToShare, setFlagsToShare] = useState([]);
  const [instance, setInstance] = useState(null);
  const [messageLength, setMessageLength] = useState(null);
  const [groupedFlagsByText, setGroupedFlagsByText] = useState([]);
  const [initialListWithFlags, setInitialListWithFlags] = useState(null);
  const [selectedFlag, setSelectedFlag] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [mousePosition, setMousePosition] = useState({ top: 0, left: 0 });
  const [citationData, setCitationData] = useState({
    author: null,
    year: null,
    title: null,
    location: null,
    publisher: null
  });
  const [initialLength, setInitialLength] = useState(null);
  const [uniqueSharers, setUniqueSharers] = useState([]);
  const [unhighlightedFlags, setUnhighlightedFlags] = useState([]);
  const [checkHighlights, setCheckHighlights] = useState(false);
  const [flagId, setFlagId] = useState(-1); // the flag id that just created
  const [highlightText, setHighlightText] = useState(-1); // the highlightText of the node id that just created
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [isPersonalPodcast, setIsPersonalPodcast] = useState(false);
  const [unmatchedFlags, setUnmatchedFlags] = useState([]);
  const [isFlagsMobileViewOpen, setIsFlagsMobileViewOpen] = useState(false);
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [isFromPdfViewerPage, setIsFromPdfViewerPage] = useState(false);

  const prevUnmatchedFlagsRef = useRef();

  useEffect(() => {
    scrollToTop();
    setIsFromPdfViewerPage(
      location?.pathname?.includes('/pdf-viewer') || false
    );

    if (window.location.href.includes('pdf')) {
      setIsFromPdfViewerPage(true);
    }
  }, []);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobileWidth(window.innerWidth <= MOBILE_MAX_WIDTH);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  useEffect(() => {
    if (!isMobileWidth && isFlagsMobileViewOpen) {
      setIsFlagsMobileViewOpen(false);
    }
    if (isFromPdfViewerPage) {
      setTimeout(() => {
        setIsFlagsMobileViewOpen(true);
      }, 2000);
    }
  }, [isMobileWidth]);

  useEffect(() => {
    if (unmatchedFlags && unmatchedFlags.length > 0 && instance && PSPDFKit) {
      if (
        !prevUnmatchedFlagsRef.current ||
        !arraysAreEqual(prevUnmatchedFlagsRef.current, unmatchedFlags)
      ) {
        Promise.all(
          unmatchedFlags.map((unmatchedFlag) => {
            return highlightUnmatchedFlag(
              PSPDFKit,
              instance,
              unmatchedFlag,
              userFields.color
            );
          })
        ).then((results) => {
          const unhighlightedFlagIds = results.filter((id) => id != null);
          updateUnhighlightedFlags(unhighlightedFlagIds);
        });

        prevUnmatchedFlagsRef.current = unmatchedFlags;
      }
    }
  }, [groupedFlagsByText, instance]);

  const openFlagAndHighlightFailureModal = () => {
    showAlertForError({
      message: 'Failed to create highlight and flag.'
    });
  };

  const updateUnhighlightedFlags = (failedHighlights) => {
    // every time a flag is highlighted in the PDF Viewer checks if it the highlight has failed
    const newFailedHighlightsFlagIds = failedHighlights.filter(
      (item) => !unhighlightedFlags.includes(item)
    );

    if (checkHighlights && newFailedHighlightsFlagIds.length > 0) {
      logFailedFlag({
        flagId: flagId,
        highlightText: highlightText
      });
      setCheckHighlights(false);
    }

    setUnhighlightedFlags((prevItems) => [
      ...new Set([...prevItems, ...newFailedHighlightsFlagIds])
    ]);
  };

  const logFailedFlag = async (flag) => {
    if (firebase.auth.currentUser) {
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        await logFlag(token, {
          flagId: flag.flagId,
          documentUrl: document,
          highlightText: flag.highlightText
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleShowCaptureFlagModal = () => {
    setShowCaptureFlagModal(true);
  };

  const handleShowAlert = () => setShowAlert(true);
  const handleCloseAlert = () => {
    setShowAlert(false);
    setMessageLength(null);
  };
  const openedAnnotationId = useRef(null);
  const mouseStopActionHasAnnotation = useRef(false);
  const isPopupOpened = useRef(false);

  const deleteAllAnnotations = () => {
    (async () => {
      let pagesAnnotations = [];
      if (instance) {
        pagesAnnotations = await Promise.all(
          Array.from({ length: instance?.totalPageCount }).map((_, pageIndex) =>
            instance.getAnnotations(pageIndex)
          )
        );
      }
      const annotationIds = pagesAnnotations.flatMap((pageAnnotations) =>
        pageAnnotations.map((annotation) => annotation.id).toArray()
      );

      await instance?.delete(annotationIds);
    })();
  };

  const handleClose = async (flag) => {
    setShowCaptureFlagModal(false);
    if (flag !== undefined) {
      await preserveFiltersIfExist(
        document, // the url
        episode.feedUrl,
        typeFilter,
        myFilter,
        mapSharedToIsShared(),
        aiFilter
      );
    }
  };

  const exportNotes = async (exportType, sortBy) => {
    if (!firebase.auth.currentUser) {
      return;
    }

    const token = await firebase.auth.currentUser.getIdToken();

    const searchCriteria = {
      fromDate: null,
      toDate: null,
      tagsName: [],
      podcastIds: episode?.podcastId ? [parseInt(episode.podcastId, 10)] : [],
      episodeIds: episodeId ? [episodeId] : [],
      flashnote: false
    };

    let notesToExport = [];
    try {
      const searchRes = await fetchSearchFlags(token, searchCriteria, true)
        .payload;

      notesToExport = (searchRes?.data || []).map((note) =>
        note.flashnote === true
          ? { ...note, tag: RESERVED_TAGS.UNTAGGED }
          : note
      );
    } catch (error) {
      notesToExport = [];
    }

    if (!notesToExport || notesToExport.length === 0) {
      swal({
        imageUrl: logo,
        title: '<div class="titleModal">Notice</div>',
        html: '<p class="contentModal">There aren\'t notes to export.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
      return;
    }

    // immediately affects this instance
    axios.defaults.responseType = 'blob';
    axios.defaults.timeout = 60000;

    const options = {
      method: 'POST',
      headers: { 'X-Firebase-Auth': token },
      url: `${config.serverURL}/notes/export?exportType=${exportType}&sortBy=${sortBy}`,
      data: notesToExport
    };

    try {
      const response = await axios(options);
      let mimeType =
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      if (exportType === 'pdf') {
        mimeType = 'application/pdf';
      } else if (exportType === 'odt') {
        mimeType = 'application/vnd.oasis.opendocument.text';
      }

      const blob = new Blob([response.data], { type: mimeType });
      saveAs(blob, `FloNotes.${exportType}`);
    } catch (error) {
      // swallow; nothing to download on failure
    } finally {
      // reset to defaults
      axios.defaults.responseType = 'text';
      axios.defaults.timeout = 30000;
    }
  };

  const preserveFiltersIfExist = async (
    documentUrl,
    podcastUrl,
    filter,
    myF,
    sharedF,
    aiF
  ) => {
    let list = [];
    let res = {};
    let listOfTags = JSON.parse(localStorage.getItem('listOfTags'));
    let listOfUsers = JSON.parse(localStorage.getItem('listOfUsers'));
    setIsLoadingFilters(true);

    if (documentUrl !== undefined) {
      //deleteAllAnnotations()
      if (firebase.auth.currentUser) {
        firebase.auth.currentUser.getIdToken().then(async (token) => {
          if (listOfTags !== null || listOfUsers !== null) {
            //filter from box
            const allResult = await getAllFlagsByDocumentUrl(
              token,
              null,
              documentUrl,
              podcastUrl,
              undefined,
              undefined,
              true,
              true,
              aiF
            );
            const groupedList = groupedByText(
              allResult?.payload.data.sentenceInfos
            );
            list = await applyFilters(
              listOfTags,
              listOfUsers,
              groupedList,
              myF
            );
            setFilters(true);
            res = await getAllFlagsByDocumentUrl(
              token,
              null,
              documentUrl,
              podcastUrl,
              list[1],
              list[2],
              myF,
              sharedF,
              aiF
            );
          } else if (filterByThumbs) {
            const tags = ['UPTAG', 'DOWNTAG'];
            res = await getAllFlagsByDocumentUrl(
              token,
              null,
              documentUrl,
              podcastUrl,
              tags,
              undefined,
              myF,
              sharedF,
              aiF
            );
          } else {
            res = await getAllFlagsByDocumentUrl(
              token,
              null,
              documentUrl,
              podcastUrl,
              undefined,
              undefined,
              myF,
              sharedF,
              aiF
            );
          }

          setIsLoadingFilters(false);
          const array = res.payload.data?.sentenceInfos;
          const unmatchedFlagsRes = res.payload?.data?.unmatchedNotes;

          setUnmatchedFlags(unmatchedFlagsRes);
          citationProp(res.payload.data?.episodeInfo);
          createListGroupedByText(array, unmatchedFlagsRes);
          setPdfFlags(array);
        });
      }
    }
  };

  const citationProp = (data) => {
    setCitationData({
      author: data?.author,
      year:
        data?.publicationYear && data?.publicationYear !== 0
          ? data?.publicationYear
          : null,
      title: data?.title,
      location: data?.publicationLocation,
      publisher: data?.publisher
    });
  };

  const handleTextClick = (text) => {
    setSelectedText(text);
  };

  const clearPopUpState = () => {
    setShouldShowCustomMenu(false);
    setCurrentAnnotation(null);
    openedAnnotationId.current = null;
  };

  const handleFlagPlay = async (listOfFlags) => {
    await setPlayerDocument1('');
    await setPlayingDocumentId1(null);
    await setPlayerFlag1(listOfFlags[0]);
    await setPlaybackFlags1(listOfFlags);
    await setPlayResource1('pdfviewer');
    if (listOfFlags.length > 1) {
      await setDisableSkipAheadButton1(false);
      await setDisableSkipBackButton1(false);
    } else {
      await setDisableSkipAheadButton1(true);
      await setDisableSkipBackButton1(true);
    }
  };

  const handleConfirmationDeleteFlagOpen = (flags) => {
    setOpenConfirmationDeleteFlagModal(true);
    setSelectedItems(flags);
  };

  const closeConfirmationDeleteModal = () => {
    setOpenConfirmationDeleteFlagModal(true);
  };

  const initFetchSearchFlags = async (url) => {
    await preserveFiltersIfExist(
      url,
      episode.feedUrl,
      typeFilter,
      myFilter,
      mapSharedToIsShared(),
      aiFilter
    );
  };

  const handleConfirmationDelete = async () => {
    try {
      await handleDeleteFlags(selectedItems);

      setSelectedItems([]);
      setOpenConfirmationDeleteFlagModal(false);
      await initFetchSearchFlags(document);
    } catch (error) {
      // Handle delete error
      console.error(error);
      setOpenConfirmationDeleteFlagModal(false);
      if (error !== 'SPECIAL_FLAGS') {
        displayNotification(`<p class="contentModal">${error.message}</p>`, {
          title: '<div class="titleModal">Delete Failed</div>',
          showConfirmButton: false,
          showCloseButton: true,
          allowOutsideClick: true
        });
      }
    }
  };

  const handleShareModalOpen = (e, flag) => {
    e.stopPropagation();
    setShareModalOpen(true);
    if (Array.isArray(flag)) {
      setFlagsToShare(flag);
    } else {
      setFlagsToShare([flag]);
    }
  };

  const handleShareModalClose = () => {
    setShareModalOpen(false);
  };

  const handleShareModalInit = async (e, flag) => {
    const {
      flagsToBeShared,
      restrictedFlags
    } = classifyFlagsForDeletionAndSharing(Array.isArray(flag) ? flag : [flag]);

    if (restrictedFlags.length > 0 && flagsToBeShared.length === 0) {
      const message =
        restrictedFlags.length === 1
          ? 'The selected flag is a system flag and cannot be shared.'
          : 'The selected flags are system flags and cannot be shared.';

      displayNotification(`<p class="contentModal">${message}</p>`, {
        showConfirmButton: false,
        showCloseButton: true,
        allowOutsideClick: true
      });
      return;
    }

    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      if (Array.isArray(flag)) {
        await getUserGroups(token, flag[0]?.feedUrl);
      } else {
        await getUserGroups(token, flag?.feedUrl);
      }
      handleShareModalOpen(e, flag);
    }
  };

  const createListGroupedByText = (initListWithFlags, unmatchedFlags) => {
    if (unmatchedFlags && unmatchedFlags.length > 0) {
      const transformedUnmatchedFlags = unmatchedFlags.map((unmatchedFlag) =>
        addTrackPositionToUnmatchedFlag(unmatchedFlag)
      );
      const result = groupedByText(
        initListWithFlags,
        transformedUnmatchedFlags
      );
      setGroupedFlagsByText(result);
    } else {
      const result = groupedByText(initListWithFlags, unmatchedFlags);
      setGroupedFlagsByText(result);
    }
  };

  const saveFlag = async (tag, comment) => {
    let tagToPost;

    if (tag === undefined || tag === null || tag === '') {
      tagToPost = 'FLASH';
    } else {
      tagToPost = tag;
    }

    const params = {
      url: episode.url,
      imgUrl: episode.imgUrl,
      tag: tagToPost,
      podcastId: episode.podcastId,
      dictation: comment && comment.trim() !== '' ? comment : null,
      artistName: episode.artistName,
      timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
      releaseDate: episode.releaseDate,
      documentName: episode.episodeName,
      podcastName: episode.podcastName,
      highlightedText: selectedText,
      pageStart: startPageIndex,
      pageEnd: endPageIndex
    };

    if (firebase.auth.currentUser) {
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const options = {
          method: 'POST',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/notes/noTrackPosition?flashnote=${
            tagToPost === 'FLASH' ? 'true' : 'false'
          }`,
          data: params
        };

        const response = await axios(options);

        // Delay before calling handleClose
        /*const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await delay(4000);*/

        handleClose(response.data);

        if (
          response?.data?.sentenceIndexes !== null ||
          response?.data?.trackPosition === -1
        ) {
          setFlagId(response.data.id);
          setHighlightText(response.data.transcriptText);
          setCheckHighlights(true);
        } else {
          openFlagAndHighlightFailureModal();
          logFailedFlag({
            flagId: response?.data?.flagdId,
            highlightText: response?.data?.transcriptText
          });
        }
      } catch (error) {
        openFlagAndHighlightFailureModal();
        logFailedFlag({
          flagId: null,
          highlightText: selectedText
        });
        console.error(error);
      }
    }
  };

  //It is called if pdfViewer need a refresh
  const handleRefreshPdfViewer = async (refreshPdfViewer) => {
    if (refreshPdfViewer) {
      await preserveFiltersIfExist(
        document,
        episode?.feedUrl,
        typeFilter,
        myFilter,
        mapSharedToIsShared(),
        aiFilter
      );
    }
  };

  const requestForToken1 = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const a = await requestForToken();
      if (firebase.auth.currentUser !== null) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          let values = {};
          values.notification_web_token = a;
          const res = setUserFields(token, values);
          if (res) {
            getUserFields(token);
          }
        });
      }
    } else {
      console.log('Notification permission does not granted.');
    }
  };

  onMessageListener()
    .then(async (payload) => {
      const p = await replaceTag(payload?.data?.flagId, payload?.data?.tag);
      if (p?.length > 0) {
        createListGroupedByText(p, unmatchedFlags);
        deleteAllAnnotations();
        setPdfFlags(p);
      }
    })
    .catch((err) => console.log('failed: ', err));

  const replaceTag = async (id, tag) => {
    const updatedData = pdfFlags?.map((item) => {
      if (item.noteInfos) {
        item.noteInfos = item.noteInfos.map((flag) => {
          if (flag.flagId === parseInt(id, 10)) {
            flag.tag = tag;
            flag.flashnote = false;
          }
          return flag;
        });
      }
      return item;
    });
    return updatedData;
  };

  const mapSharedToIsShared = () => {
    if (sharedFilter == 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleSharedFlagsUsers = (data) => {
    const uniqueSharers = [];
    const uniqueUserIds = new Set();
    data?.forEach((item) => {
      if (!uniqueUserIds.has(item.userId)) {
        uniqueUserIds.add(item.userId);
        uniqueSharers.push(item);
      }
    });
    setUniqueSharers(uniqueSharers);
  };

  useEffect(() => {
    setInitialLength(newFlags?.length);
    setFlagFilters({
      ...initialFlagFilters,
      documentUrl: document,
      podcastUrl: episode.feedUrl
    });
    setMyFilter(true);
    setSharedFilter(true);
    setAiFilter(false);

    const documentList = allDocuments.filter(
      (item) => String(item.id) === String(pdfViewerDocumentId)
    );
    if (documentList?.length > 0) {
      setIsPersonalPodcast(documentList[0].isOwner);
    }
  }, []);

  // First fetch flags
  useEffect(() => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        const res = await getAllFlagsByDocumentUrl(
          token,
          null,
          episode?.url,
          episode?.feedUrl
        );
        if (res.payload.status === 200) {
          const unmatchedFlags = res.payload.data?.unmatchedNotes;

          createListGroupedByText(
            res.payload.data?.sentenceInfos,
            unmatchedFlags
          );
          setInitialListWithFlags(res.payload.data?.sentenceInfos);
          setUnmatchedFlags(unmatchedFlags);
          setPdfFlags(res.payload.data?.sentenceInfos);
          citationProp(res.payload.data?.episodeInfo);
        }
      });
    }

    localStorage.setItem('documentName', episode.episodeName);
  }, []);

  useEffect(() => {
    let array = [];
    Object.entries(groupedFlagsByText).forEach(([key, flags]) => {
      const filteredFlags = flags.filter((flag) => flag.isShared);
      if (filteredFlags.length > 0) {
        array = [...array, ...filteredFlags];
      }
    });
    handleSharedFlagsUsers(array);
  }, [initialListWithFlags]);

  useEffect(() => {
    /*only when we have a new flag and playerDocument from recentFlo, last5Listened, notifications and document
    from documents tab and pdfViewerdocumentId is the same, reload viewer*/
    if (initialLength !== null && initialLength < newFlags?.length) {
      if (
        playerDocument?.id === parseInt(pdfViewerDocumentId, 10) ||
        playerDocument?.document?.id === parseInt(pdfViewerDocumentId, 10) ||
        playerDocument?.documentId === parseInt(pdfViewerDocumentId, 10) ||
        playerDocument?.id === pdfViewerDocumentId
      ) {
        preserveFiltersIfExist(
          document,
          episode?.feedUrl,
          typeFilter,
          myFilter,
          mapSharedToIsShared(),
          aiFilter
        );
      }
    }
  }, [initialLength, newFlags]);

  useEffect(() => {
    requestForToken1();
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    let PSPDFKit, instance;
    let txt, selectedTxt;
    let timer;
    let arrayPage = [];

    if (instance != null) {
      if (!isSetupComplete.current) {
        instance.addEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
      } else {
        instance.removeEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
      }
    }
    const pageChangeListener = (pageIndex) => {
      localStorage.setItem('pageIndex', pageIndex);
      setStartPageIndex(pageIndex);
      if (!arrayPage.includes(pageIndex)) {
        createHighlightByPage(
          PSPDFKit,
          instance,
          pageIndex,
          filterByThumbs,
          initialListWithFlags
        ).then((result) => {
          updateUnhighlightedFlags(result);
        });
        arrayPage.push(pageIndex);
      }
    };

    if (initialListWithFlags !== null && !isSetupComplete.current) {
      (async function() {
        PSPDFKit = await import('pspdfkit');
        setPSPDFKit(PSPDFKit);
        PSPDFKit.unload(container);
        const configuration = {
          licenseKey: process.env.REACT_APP_LICENSE_KEY_PDF_VIEWER,
          disableWebAssemblyStreaming: true,
          instant: false,
          styleSheets:
            process.env.PUBLIC_URL && process.env.PUBLIC_URL !== ''
              ? ['./css/pspdfkit.css']
              : ['/css/pspdfkit.css'],
          // Container where PSPDFKit should be mounted.
          container,
          // The document to open.
          document: document,
          theme: PSPDFKit.Theme.DARK,
          // Use the public directory URL as a base URL. PSPDFKit will download its library assets from here.
          baseUrl:
            process.env.PUBLIC_URL && process.env.PUBLIC_URL !== ''
              ? `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}/`
              : `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}`,
          customRenderers: {
            Annotation: ({ annotation }) => {
              if (
                annotation instanceof PSPDFKit.Annotations.TextAnnotation ||
                annotation instanceof PSPDFKit.Annotations.MarkupAnnotation ||
                annotation instanceof PSPDFKit.Annotations.LinkAnnotation ||
                annotation instanceof
                  PSPDFKit.Annotations.HighlightAnnotation ||
                annotation instanceof PSPDFKit.Annotations.UnderlineAnnotation
              ) {
                const node = instance.contentDocument.createElement('div');
                node.classList.add('myAnnotationCustom');
                node.dataset.annotationId = annotation.id;
                node.style.cssText =
                  'position: absolute; width: 100%; height: 300px; overflow: auto;pointer-events: auto;';
                node.innerHTML = `<div data-title="${annotation.id}"></div>`;

                /**
                 * Function that triggered from mouse enter event
                 * @param {*} e
                 * @returns
                 */
                const mouseoverListener = async function(e) {
                  e.preventDefault();
                  e.stopPropagation();

                  // if match the conditional means that we have another opened annotation and return the value
                  // openedAnnotationId.current is null at first time and when we close the popup and clear the popUpState
                  if (
                    openedAnnotationId.current !== null &&
                    openedAnnotationId.current !== annotation.id
                  )
                    return;
                  if (isPopupOpened.current) return;

                  if (annotation) {
                    mouseStopActionHasAnnotation.current = true;
                  }
                };

                /**
                 * Function that triggered from mouse leave event
                 * @param {*} e
                 */
                const mouseLeaveListener = (e) => {
                  if (isPopupOpened.current) return;
                  e.preventDefault();
                  e.stopPropagation();
                  // console.log("TRIGGER MOUSELEAVE");
                  mouseStopActionHasAnnotation.current = false;
                };

                /**
                 * Function that triggered when mouse moving stops and you are inside an annotation node
                 */
                const handleOpenPopup = () => {
                  setCurrentAnnotation(annotation);
                  openedAnnotationId.current = annotation.id;
                  setShouldShowCustomMenu(true);
                  isPopupOpened.current = true;
                  setShowPopup(true);
                  const attr = node.getAttribute('data-annotation-id');
                  const myEl = instance.contentDocument.querySelector(
                    `.myAnnotationCustom[data-annotation-id="${attr}"]`
                  );
                  if (myEl !== null) {
                    myEl.style.cssText =
                      'pointer-events: none!important; width: 0!important; height: 0;!important';
                  }
                };

                /**
                 * Function that triggered when mouse moving stops and you are out of annotation node
                 */
                const handleCancelPopup = () => {
                  if (!isPopupOpened.current) {
                    setCurrentAnnotation(null);
                    setShouldShowCustomMenu(false);
                    // setShowPopup(false);
                    node.style.cssText =
                      'position: absolute; width: 100%; height: 100%;pointer-events: auto;';
                  }
                };

                /**
                 * Function that triggered with mousemove event and when stop moving mouse in triggers the logic inside setTimeout
                 * @param {*} event
                 */
                const handleMouseMove = (event) => {
                  if (isPopupOpened.current) return;

                  clearTimeout(timer);

                  timer = setTimeout(() => {
                    if (annotation && mouseStopActionHasAnnotation.current) {
                      const popupWidth = 300;
                      const popupHeight = 200;
                      const padding = 20;

                      let x = event.pageX - 80;
                      let y = event.pageY - 120;

                      const viewportWidth = window.innerWidth;
                      const viewportHeight = window.innerHeight;

                      // Adjust horizontal position if popup would extend beyond right edge
                      if (x + popupWidth + padding > viewportWidth) {
                        x = viewportWidth - popupWidth - padding;
                      }

                      // Adjust horizontal position if popup would extend beyond left edge
                      if (x < padding) {
                        x = padding;
                      }

                      // Adjust vertical position if popup would extend beyond bottom edge
                      if (y + popupHeight + padding > viewportHeight) {
                        y = viewportHeight - popupHeight - padding;
                      }

                      // Adjust vertical position if popup would extend beyond top edge
                      if (y < padding) {
                        y = padding;
                      }

                      const mousePosition = {
                        event: event,
                        x: x,
                        y: y
                      };
                      setMousePosition({
                        top: mousePosition.y,
                        left: mousePosition.x
                      });
                      handleOpenPopup();
                    } else {
                      handleCancelPopup();
                    }
                    node.removeEventListener('mousemove', handleMouseMove);
                  }, 500);
                };

                node.addEventListener('mouseenter', mouseoverListener, {
                  once: true
                });
                node.addEventListener('mouseleave', mouseLeaveListener, {
                  once: true
                });
                node.addEventListener('mousemove', handleMouseMove);

                return {
                  node,
                  append: true
                };
              }
            }
          }
        };

        instance = await PSPDFKit.load({
          ...configuration
        });

        setInstance(instance);

        if (
          localStorage.getItem('pageIndex') !== null &&
          localStorage.getItem('pageIndex') !== ''
        ) {
          instance.setViewState((viewState) =>
            viewState.set(
              'currentPageIndex',
              parseInt(localStorage.getItem('pageIndex'), 10)
            )
          );
          createHighlightByPage(
            PSPDFKit,
            instance,
            parseInt(localStorage.getItem('pageIndex'), 10),
            filterByThumbs,
            initialListWithFlags
          ).then((result) => {
            updateUnhighlightedFlags(result);
          });
          arrayPage.push(parseInt(localStorage.getItem('pageIndex'), 10));
          localStorage.removeItem('pageIndex');
        } else {
          if (!arrayPage.includes(0)) {
            createHighlightByPage(
              PSPDFKit,
              instance,
              0,
              filterByThumbs,
              initialListWithFlags
            ).then((result) => {
              updateUnhighlightedFlags(result);
            });
            arrayPage.push(0);
          }
        }

        setInstance(instance);

        function pressAnnotationListener(pressedAnnotation) {
          pressedAnnotation.preventDefault();
          const selectedFlagId =
            pressedAnnotation?.annotation.customData?.flagsList[0]?.flagId;
          const text = pressedAnnotation?.annotation.subject;
          setSelectedFlag(selectedFlagId);
          setSelectedText(text);
        }

        instance.addEventListener('annotations.press', pressAnnotationListener);

        const handleSearchMessage = async (event) => {
          const { text: searchText, pageStart, flagId } = event.data;
          if (typeof searchText === 'string' || searchText instanceof String) {
            const newText = getFirst15Words(searchText);
            //search only for the first 15 words of the flag in order to avoid crash on search
            try {
              const results = await instance.search(
                newText?.replace(/\r?\n|\r/g, '')
              );
              const flag = results.toJS();

              const foundHighlightPosition = flag.some((result, i) => {
                let position = new PSPDFKit.Geometry.Rect({
                  left: result.rectsOnPage[0].left,
                  top: result.rectsOnPage[0].top,
                  width: result.rectsOnPage[0].width,
                  height: result.rectsOnPage[0].height
                });

                if (
                  pageStart === undefined &&
                  typeof result.pageIndex == 'number'
                ) {
                  instance.jumpToRect(result.pageIndex, position);
                  return true;
                }

                if (pageStart === result.pageIndex) {
                  instance.jumpToRect(result.pageIndex, position);
                  return true;
                }
                return false;
              });

              if (!foundHighlightPosition) {
                // the flag could not be highlighted
                setUnhighlightedFlags((prevItems) => [
                  ...new Set([...prevItems, flagId])
                ]);
              }
            } catch (error) {
              console.error(error);
              // TODΟ error handling
            }
          }
        };

        window.addEventListener('message', (event) => {
          if (!ALLOWED_ORIGINS.includes(event.origin)) {
            console.warn('Blocked message from unkown origin: ', event.origin);
            return;
          }

          handleSearchMessage(event).catch((error) => {
            console.error('Error handling search message:', error);
          });
        });

        /**
         * Listener for textSelection change.
         * In our function we keep the original textSelection from pdf viewer and the real text from getText() method.
         */
        const textSelectionChangeListener = (textSelection) => {
          if (textSelection) {
            setStartPageIndex(textSelection.startPageIndex);
            setEndPageIndex(textSelection.endPageIndex);
            selectedTxt = textSelection;
            selectedTxt.getText().then(async (text) => {
              setSelectedText(text);
              txt = text;
            });
          }
        };

        instance.addEventListener(
          'textSelection.change',
          textSelectionChangeListener
        );

        const node = instance.contentDocument.createElement('div');
        const imageNode = instance.contentDocument.createElement('img');
        imageNode.src = highlightButton;
        const button = instance.contentDocument.createElement('button');
        button.type = 'button';
        button.textContent = 'Create Flag';
        button.id = 'pop-up-flag-button';

        Object.assign(button.style, {
          background: '#2a906e',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          padding: '10px 16px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer'
        });

        node.appendChild(button);

        const itemHighlightBtn = {
          type: 'custom',
          id: 'highlight',
          title: 'Create Flag',
          node: node,
          onmousedown: (e) => {
            alert('on mouse down');
            e.preventDefault();
            e.stopPropagation();
          },
          onPress: async () => {
            if (txt && selectedTxt) {
              setSelectedObj(selectedTxt);
              selectedTxt.getText().then(async (text) => {
                setSelectedText(text);
                const clearText = text.replace(/\r?\n|\r/g, '');
                const length = clearText.length;
                if (length < config.minLengthOfSentence) {
                  handleShowAlert();
                  setMessageLength(
                    'You must select a larger portion of text to highlight. Please select a portion of text that contains between 100 and 580 characters.'
                  );
                } else {
                  // get the position of the button

                  handleShowCaptureFlagModal();
                }
              });
            }
            txt = null;
            selectedTxt = null;
          }
        };

        await instance.setInlineTextSelectionToolbarItems(
          ({ defaultItems }, selection) => {
            return [itemHighlightBtn];
          }
        );

        instance.addEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
        isSetupComplete.current = true;
      })();
      return () => {
        instance?.removeEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
      };
    }
  }, [document, initialListWithFlags, pdfFlags]);

  const prevPdfFlagsRef = useRef();

  useEffect(() => {
    let arrayPage = [];
    const pageChangeListener = (pageIndex) => {
      localStorage.setItem('pageIndex', pageIndex);
      setStartPageIndex(pageIndex);
      if (!arrayPage.includes(pageIndex)) {
        createHighlightByPage(
          PSPDFKit,
          instance,
          pageIndex,
          filterByThumbs,
          pdfFlags
        ).then((result) => {
          updateUnhighlightedFlags(result);
        });
        arrayPage.push(pageIndex);
      }
    };
    deleteAllAnnotations();
    if (pdfFlags !== prevPdfFlagsRef.current && pdfFlags?.length >= 0) {
      if (instance !== null && pageChangeListener) {
        if (
          localStorage.getItem('pageIndex') !== null &&
          localStorage.getItem('pageIndex') !== ''
        ) {
          createHighlightByPage(
            PSPDFKit,
            instance,
            parseInt(localStorage.getItem('pageIndex'), 10),
            filterByThumbs,
            pdfFlags
          ).then((result) => {
            updateUnhighlightedFlags(result);
          });

          arrayPage.push(parseInt(localStorage.getItem('pageIndex'), 10));
        } else {
          if (!arrayPage.includes(0)) {
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser.getIdToken().then(async (token) => {
                const res = await getAllFlagsByDocumentUrl(
                  token,
                  null,
                  document,
                  episode?.feedUrl
                );

                if (res.payload.status === 200) {
                  const unmatchedFlagsRes = res.payload.data?.unmatchedNotes;

                  setUnmatchedFlags(unmatchedFlagsRes);
                }
              });
            }

            createHighlightByPage(
              PSPDFKit,
              instance,
              0,
              filterByThumbs,
              pdfFlags
            ).then((result) => {
              updateUnhighlightedFlags(result);
            });
            arrayPage.push(0);
          }
        }
        instance.addEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
      }
      prevPdfFlagsRef.current = pdfFlags;
      return () => {
        instance?.removeEventListener(
          'viewState.currentPageIndex.change',
          pageChangeListener
        );
      };
    }
  }, [pdfFlags]);

  useEffect(() => {
    if (isFlagCreatedByPlayer) {
      const flags = allFlagsByDocument.data?.sentenceInfos;
      const unmatchedFlags = allFlagsByDocument.data?.unmatchedNotes;
      const citationData = allFlagsByDocument.data?.episodeInfo;
      createListGroupedByText(flags, unmatchedFlags);
      setPdfFlags(flags);
      citationProp(citationData);
      resetFlagCreationStatus();
    }
  }, [isFlagCreatedByPlayer]);

  // This div element will render the document to the DOM.
  return (
    <>
      {isMobileWidth && (
        <PdfViewerHeadline
          isFromPdfViewerPage={isFromPdfViewerPage}
          isMobileWidth={isMobileWidth}
          isInitialized={!!instance}
          onClosePdfViewer={handleClosePdfViewer}
          isFlagsMobileViewOpen={isFlagsMobileViewOpen}
          setIsFlagsMobileViewOpen={setIsFlagsMobileViewOpen}
        />
      )}

      <div
        style={{
          display: 'flex',
          alignContent: 'stretch',
          position: 'relative'
        }}
      >
        <div
          style={{
            flex: isMobileWidth ? 1 : '0 0 75%',
            height: '100vh',
            background: '#F6F8FA'
          }}
        >
          {instance === null && (
            <SkeletonWrapper>
              <SkeletonHeader>
                <SkeletonWave height={40} backgroundColor="#eee" />
              </SkeletonHeader>
              <SkeletonBody>
                <SkeletonWave height="80vh" backgroundColor="#eee" />
              </SkeletonBody>
            </SkeletonWrapper>
          )}
          <div
            key={document}
            ref={containerRef}
            style={{
              flex: isMobileWidth ? 1 : '0 0 75%',
              height: '100vh',
              display: instance === null ? 'none' : 'block'
            }}
          ></div>
        </div>
        {!isMobileWidth && !isFlagsMobileViewOpen && (
          <FlagsRightSide
            groupedFlagsByText={groupedFlagsByText}
            documentUrl={document}
            selectedText={selectedText}
            selectedFlag={selectedFlag}
            onScrollToText={handleTextClick}
            PSPDFKit={PSPDFKit}
            container={containerRef}
            handleRefreshPdfViewer={handleRefreshPdfViewer}
            instance={instance}
            preserveFiltersIfExist={preserveFiltersIfExist}
            isLoadingFilters={isLoadingFilters}
            setIsLoadingFilters={setIsLoadingFilters}
            citationData={citationData}
            podcastUrl={episode.feedUrl}
            expand={expand}
            handleClickExpand={handleClickExpand}
            handleClosePdfViewer={handleClosePdfViewer}
            handleShareModalInit={handleShareModalInit}
            uniqueSharers={uniqueSharers}
            unhighlightedFlags={unhighlightedFlags}
            isPersonalPodcast={isPersonalPodcast}
            isMobileWidth={isMobileWidth ?? false}
            isFromPdfViewerPage={isFromPdfViewerPage || false}
            exportNotes={exportNotes}
          />
        )}

        <FlagsFullscreenOverlay
          isFlagsMobileViewOpen={isFlagsMobileViewOpen}
          isFromPdfViewerPage={isFromPdfViewerPage}
          setIsFlagsMobileViewOpen={setIsFlagsMobileViewOpen}
          component={
            <FlagsRightSide
              groupedFlagsByText={groupedFlagsByText}
              documentUrl={document}
              selectedText={selectedText}
              selectedFlag={selectedFlag}
              onScrollToText={handleTextClick}
              PSPDFKit={PSPDFKit}
              container={containerRef}
              handleRefreshPdfViewer={handleRefreshPdfViewer}
              instance={instance}
              preserveFiltersIfExist={preserveFiltersIfExist}
              isLoadingFilters={isLoadingFilters}
              setIsLoadingFilters={setIsLoadingFilters}
              citationData={citationData}
              podcastUrl={episode.feedUrl}
              expand={expand}
              handleClickExpand={handleClickExpand}
              handleClosePdfViewer={handleClosePdfViewer}
              handleShareModalInit={handleShareModalInit}
              uniqueSharers={uniqueSharers}
              unhighlightedFlags={unhighlightedFlags}
              isPersonalPodcast={isPersonalPodcast}
              isMobileWidth={isMobileWidth ?? false}
              exportNotes={exportNotes}
              isFromPdfViewerPage={isFromPdfViewerPage || false}
            />
          }
        />

        <CommentModal
          open={showPopup}
          flagData={currentAnnotation}
          onClose={() => {
            setShowPopup(false);
            clearPopUpState();
            isPopupOpened.current = false;
          }}
          popupPosition={mousePosition}
          instance={instance}
          handleFlagPlay={handleFlagPlay}
          handleConfirmationDeleteFlagOpen={handleConfirmationDeleteFlagOpen}
          handleShareModalInit={handleShareModalInit}
          isPersonalPodcast={isPersonalPodcast}
        />
      </div>
      {showCaptureFlagModal && (
        <HighlightFlagWithJudgement
          open={showCaptureFlagModal}
          onClose={handleClose}
          dialogClassName="custom-modal-size"
          saveFlag={saveFlag}
          isMobileWidth={isMobileWidth}
          setInputCommentName={setInputCommentName}
          setInputTagName={setInputTagName}
          setRadioButtonValue={setRadioButtonValue}
          inputCommentName={inputCommentName}
          inputTagName={inputTagName}
          radioButtonValue={radioButtonValue}
          instance={instance}
          isPersonalPodcast={isPersonalPodcast}
          PSPDFKit={PSPDFKit}
        />
      )}
      {openConfirmationDeleteFlagModal && (
        <ConfirmationDeleteModal
          open={openConfirmationDeleteFlagModal}
          flags={selectedItems}
          onCancel={closeConfirmationDeleteModal}
          onConfirm={handleConfirmationDelete}
        />
      )}
      {shareModalOpen && (
        <ShareFlags
          open={shareModalOpen}
          onClose={handleShareModalClose}
          flagsToShare={flagsToShare}
        />
      )}
      <AlertLengthModal
        open={showAlert}
        onClose={handleCloseAlert}
        message={messageLength}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsSelectedFlags1: async (value) => {
      await dispatch(setIsSelectedFlags(value));
    },
    setPlayerFlag1: async (value) => {
      await dispatch(setPlayerFlag(value));
    },
    setPlayerDocument1: async () => {
      await dispatch(setPlayerDocument(''));
    },
    setPlayingDocumentId1: async () => {
      await dispatch(setPlayingDocumentId(null));
    },
    setPlaybackFlags1: async (array) => {
      await dispatch(setPlaybackFlags(array));
    },
    setDisableSkipAheadButton1: async (value) => {
      await dispatch(setDisableSkipAheadButton(value));
    },
    setDisableSkipBackButton1: async (value) => {
      await dispatch(setDisableSkipBackButton(value));
    },
    setShowSkipButton1: async (value) => {
      await dispatch(setShowSkipButton(value));
    },
    setPlayResource1: async (value) => {
      await dispatch(setPlayResource(value));
    },
    getUserGroups: async (token, values) => {
      await dispatch(fetchUserGroups(token, values));
    },
    setFilterByThumbs: async (value) => {
      await dispatch(setFilterByThumbs(value));
    },
    getAllFlagsByDocumentUrl: async (
      token,
      pageSatrt,
      documentUrl,
      podcastUrl,
      tags,
      users,
      isMine,
      isShared,
      isAiFlags
    ) => {
      const res = await dispatch(
        fetchAllFlagsByDocumentUrl(
          token,
          pageSatrt,
          documentUrl,
          podcastUrl,
          tags,
          users,
          isMine,
          isShared,
          isAiFlags
        )
      );
      return res;
    },
    setPdfFlags: async (value) => {
      await dispatch(setPdfFlags(value));
    },
    setMyFilter: async (value) => {
      await dispatch(setMyFilter(value));
    },
    setSharedFilter: async (value) => {
      await dispatch(setSharedFilter(value));
    },
    setAiFilter: async (value) => {
      await dispatch(setAiFilter(value));
    },
    setFilters: async (value) => {
      await dispatch(setFilters(value));
    },
    setTypeFilter: async (value) => {
      await dispatch(setTypeFilter(value));
    },
    setUserFields: async (token, values) => {
      const res = await dispatch(updateUserFields(token, values));
      return res;
    },
    getUserFields: async (token) => {
      await dispatch(fetchUserFields(token));
    },
    setFlagFilters: async (value) => {
      await dispatch(setFlagFilters(value));
    },
    resetFlagCreationStatus: async (value) => {
      await dispatch(resetFlagCreationStatus(value));
    }
  };
};

const mapStateToProps = (state) => ({
  pdfViewerDocumentId: state.pdf.pdfViewerDocumentId,
  playerDocument: state.player.playerDocument,
  filterByThumbs: state.pdf.filterByThumbs,
  allFlagsByDocument: state.pdf.allFlagsByDocument,
  pdfFlags: state.pdf.pdfFlags,
  myFilter: state.pdf.myFilter,
  sharedFilter: state.pdf.sharedFilter,
  aiFilter: state.pdf.aiFilter,
  filters: state.pdf.filters,
  typeFilter: state.pdf.typeFilter,
  isFlagCreatedByPlayer: state.pdf.isFlagCreatedByPlayer,
  allDocuments: state.player.allDocuments,
  userFields: state.app.userFields
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PdfViewerComponent)
);
